import injector from 'vue-inject'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    newItem: null,
    cart: {},
    favorites: {}
  },
  getters: {
    discountTotalPrice: (state, getters, rootState, rootGetters) => { // 折扣後的價格
      return getters.totalPrice - getters.discountAmount
    },
    discountAmount: (state, getters, rootState) => Math.round(getters.totalPrice * rootState.paymentMethodDiscount / 100),
    totalPrice: (state, getters, rootState, rootGetters) => Math.round(getters.subtotal * rootGetters.serviceCharge / 100 + getters.subtotal),
    subtotal: (state, getters, rootState, rootGetters) =>
      !rootGetters.currentMenu || getters.allItemObjs.length === 0
        ? 0
        : Math.round(getters.allItemObjs.reduce((total, obj) =>
          total + injector.get('CartElementBuilder').buildItem(obj, rootGetters.currentMenu).totalPrice, 0)),
    allItemObjs: state => Object.keys(state.cart).map(k => state.cart[k]).reduce((a, b) => a.concat(Object.keys(b).map(k => b[k])), []),
    allFavoriteItems: state => Object.keys(state.favorites).map(k => state.favorites[k]).reduce((a, b) => a.concat(Object.keys(b).map(k => b[k])), [])
  },
  mutations,
  actions
}
